import { useTranslation, Trans } from 'next-i18next'

import { LeagueType } from '~/Leaderboard/types/leaderboard.types'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { NotificationMessage } from '~/shared/types/notification.types'

export default function JoinLeaderboardNotification({ message }: { message: NotificationMessage }): React.ReactElement {
  const { t } = useTranslation('gamification')
  const LeagueName = Object.entries(LeagueType)
    .filter(([, value]) => value === parseInt(message.league || '1'))
    .map(([key]) => key)
    .toString()
    .toLowerCase()

  const badgeSrckey = `gamification/badges/league/${LeagueName}-badge.svg`
  return (
    <>
      <div className="flex items-center pt-2">
        <ResponsiveImage
          alt={t(`league.${LeagueName}`)}
          className="min-w-max px-5"
          fit="contain"
          height={75}
          imageWidths="56"
          srcKey={badgeSrckey}
          width={56}
        />
        <div className="flex flex-col justify-center pr-4">
          <h3 className="font-semibold text-md uppercase">{`${t('congratulations')}!`} </h3>
          <p className="text-sm">
            {Trans({
              t,
              i18nKey: 'youJoined',
              values: { league: t(`league.${LeagueName}`) },
              components: { strong: <strong className="font-semibold" /> },
              children: t('youJoined'),
            })}
          </p>
        </div>
      </div>
    </>
  )
}
